/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoChangeShipmentContainerInput = {
    clientMutationId?: string | null;
    shipmentSlug: string;
    containerSlug: string;
};
export type SearchContainersMutationVariables = {
    input: infoChangeShipmentContainerInput;
};
export type SearchContainersMutationResponse = {
    readonly infoChangeShipmentContainer: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SearchContainersMutation = {
    readonly response: SearchContainersMutationResponse;
    readonly variables: SearchContainersMutationVariables;
};



/*
mutation SearchContainersMutation(
  $input: infoChangeShipmentContainerInput!
) {
  infoChangeShipmentContainer(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeShipmentContainerPayload",
    "kind": "LinkedField",
    "name": "infoChangeShipmentContainer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchContainersMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchContainersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aaf6a12dae1429e3400430a98d4235eb",
    "id": null,
    "metadata": {},
    "name": "SearchContainersMutation",
    "operationKind": "mutation",
    "text": "mutation SearchContainersMutation(\n  $input: infoChangeShipmentContainerInput!\n) {\n  infoChangeShipmentContainer(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bfa3d98fd884b4cc63d2425b4b62d5be';
export default node;
